interface Props {
  className?: string
}

export function Skeleton({ className = '' }: Props) {
  return <div className={`skeleton ${className}`} />
}

export function CardSkeleton() {
  return (
    <div className="bg-surface-1 border border-line-1 rounded-lg p-4 space-y-3">
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-4/5" />
    </div>
  )
}

export function RowSkeleton() {
  return (
    <div className="bg-surface-1 border border-line-1 rounded-lg p-4 flex items-center gap-3">
      <Skeleton className="h-4 w-4/5" />
      <Skeleton className="h-4 w-8 ml-auto" />
    </div>
  )
}

